import {useContext} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import {htmlStringToReactElement} from '@s-ui/js/lib/react'
import Context from '@s-ui/react-context'
import {useMediaQuery, useMediaQueryBreakpoints} from '@adv-mt/mt-layout-render-media-query'
import IconCalculator from '@adv-mt/mt-svg-icons/lib/CalculatorOutline.js'
import CarOutline from '@adv-mt/mt-svg-icons/lib/CarOutline.js'
import FileDocumentOutline from '@adv-mt/mt-svg-icons/lib/FileDocumentOutline.js'
import IconMail from '@adv-mt/mt-svg-icons/lib/MailOutline.js'
import IconScf from '@adv-mt/mt-svg-icons/lib/Scf.js'

export const PanelFinancingClaims = ({ad, financingData, isProfessional}) => {
  const {i18n} = useContext(Context)
  const isMobile = !useMediaQuery(useMediaQueryBreakpoints.md)

  const contentItems = {
    b2c: [
      {
        icon: FileDocumentOutline,
        label: isMobile ? 'PANEL_FINANCING.B2C.EXPERIMENT_CLAIM_1' : 'PANEL_FINANCING.B2C.EXPERIMENT_CLAIM_1_DESKTOP'
      },
      {
        icon: CarOutline,
        label: 'PANEL_FINANCING.B2C.EXPERIMENT_CLAIM_2'
      }
    ],
    c2c: [
      {icon: IconCalculator, label: 'C2C.CLAIM_TEXT_1'},
      {icon: IconScf, label: 'C2C.CLAIM_TEXT_2'},
      {icon: IconMail, label: 'C2C.CLAIM_TEXT_3'}
    ]
  }

  const items = isProfessional ? contentItems.b2c : contentItems.c2c

  const classNameContent = cx('mt-PanelFinancing-claims', {
    'mt-PanelFinancing-claimsB2C': isProfessional
  })

  const classNameClaimsItem = cx('mt-PanelFinancing-claimsItem', {
    'mt-PanelFinancing-claimsItemB2C': isProfessional
  })

  return (
    <div className={classNameContent}>
      {items.map(({icon: Icon, label}, i) => {
        return (
          <div className={classNameClaimsItem} key={`${i}-${label}`}>
            <div className="mt-PanelFinancing-claimsItemIcon">
              <Icon size="medium" />
            </div>
            <div className="mt-PanelFinancing-claimsItemText">
              {htmlStringToReactElement(
                i18n.t(label, {
                  highlightStart: '<strong>',
                  highlightEnd: '</strong>'
                })
              )}
            </div>
          </div>
        )
      })}
    </div>
  )
}

PanelFinancingClaims.propTypes = {
  ad: PropTypes.object,
  financingData: PropTypes.object,
  isProfessional: PropTypes.string
}
